/* eslint-disable eqeqeq */
import { useFormikContext } from "formik";
// import { Button } from "./ui/button";

import { Input } from "./ui/input";
import Combobox from "./Combobox";
import CustomLabelText from "./CustomLabelText";
import { Label } from "./ui/label";
import { DateInputPicker } from "./DateInputPicker";
// import UserSelect from "./UserSelect";
// import { Loader2 } from "lucide-react";
import moment from "moment";
import { Button } from "./ui/button";
import { Loader2, Plus, Trash2 } from "lucide-react";
import { toast } from "./ui/use-toast";
import KYCVerifyModal from "./Assessment_KYC/KYCVerifyModal";
import UserSelect from "./UserSelect";

export default function VerificationRow({
  index,
  values,
  errors,
  push,
  remove,
  verificationMethods,
  verificationTypes,
  organizationData,
  mainData,
  loading,
  setLoading,
  kycId,
  handleBlur,
  handleChange,
  userListing,
  setUserList,
  userLoading,
  setUserLoading,
  user
}) {
  const { setFieldValue } = useFormikContext();

  const method = values.verifications[index]?.method;
  const selectedTypeId = values.verifications[index]?.type;

  const selectedType = verificationTypes?.find((t) => t.id === selectedTypeId);

  // const methods = values.verifications || [];

  // const selectedMethods = methods?.map((v) => v?.method)?.filter(Boolean);

  const filteredMethods = verificationMethods.filter((m) => {
    // if ((m.value === 3 || m.value === 5) && selectedMethods.includes(m.value)) {
    //   return false;
    // }
    return true;
  });

  return (
    <div className="border rounded-xl p-3 space-y-2">
      {/* <div className="flex items-start justify-between">
        <h4 className="p-0 m-0 font-bold">Document - {index + 1}</h4>
      </div> */}
      {/* Header */}
      <div className="flex items-start justify-between">
        <h5 className="p-0 m-0 font-semibold">Document {index + 1}</h5>

        <div className="flex gap-2 justify-end">
          {values.verifications.length < 2 && (
            <Button
              type="button"
              className="h-fit w-fit p-1 "
              onClick={() => {
                push({
                  method: "",
                  type: "",
                  document_number: "",
                  date_verified: "",
                  verified_by: "",
                  verified: "",
                  mobile: values?.mobile ? values?.mobile : "",
                  dynamicFields: {},
                });
              }}
            >
              <Plus size={20} />
            </Button>
          )}

          {values.verifications.length > 1 &&
            !values?.verifications?.[index]?.verified_status && (
              <Button
                type="button"
                className="h-fit w-fit p-1 bg-red-500"
                onClick={() => remove(index)}
              >
                <Trash2 size={20} />
              </Button>
            )}
        </div>
      </div>

      <div className="grid md:grid-cols-3 gap-4">
        {/* METHOD */}

        <div className="space-y-2">
          <Label htmlFor="trust_id">
            <CustomLabelText
              required={false}
              labelText="Verification Method"
              errorField={errors?.verifications?.[index]?.method}
            />
          </Label>
          <Combobox
            options={filteredMethods.map((t) => ({
              label: t.title,
              value: t.value,
            }))}
            isClearable={true}
            onClear={() => {
              setFieldValue(`verifications.${index}.method`, "");
              setFieldValue(`verifications.${index}.type`, "");
              setFieldValue(`verifications.${index}.document_number`, "");
            }}
            value={method || ""}
            placeholder="Select method"
            onChange={(value) => {
              const selectedMethod = Number(value);

              if ([2, 3].includes(selectedMethod)) {
                const hasMethod2 = values?.verifications?.some(
                  (v, i) => i !== index && Number(v?.method) === 2,
                );

                const hasMethod3 = values?.verifications?.some(
                  (v, i) => i !== index && Number(v?.method) === 3,
                );

                if (
                  (selectedMethod === 2 && (hasMethod2 || hasMethod3)) ||
                  (selectedMethod === 3 && (hasMethod2 || hasMethod3))
                ) {
                  toast({
                    variant: "destructive",
                    description: `DVS Method can only be used once across all verifications.`,
                  });
                  return;
                }
              }

              setFieldValue(`verifications.${index}.method`, selectedMethod);
              setFieldValue(`verifications.${index}.document_number`, "");

              if (selectedMethod === 2) {
                setFieldValue(`verifications.${index}.type`, "");
              }
            }}
            disabled={
              values?.verifications?.[index]?.verified_status ? true : false
            }
            className={
              errors?.verifications?.[index]?.method &&
              `focus-visible:ring-red-500 border-red-500`
            }
          />
        </div>

        {/* DOCUMENT TYPE */}

        {method !== 2 && method ? (
          <div className="space-y-2">
            <Label htmlFor="trust_id">
              <CustomLabelText
                required={false}
                labelText="Document Id"
                errorField={errors?.verifications?.[index]?.type}
              />
            </Label>
            <Combobox
              options={verificationTypes.map((t) => ({
                label: t.label,
                value: t.id,
              }))}
              value={selectedTypeId || ""}
              placeholder="Select method"
              onChange={(value) => {
                setFieldValue(`verifications.${index}.type`, value);
                setFieldValue(`verifications.${index}.dynamicFields`, {});
              }}
              disabled={
                values?.verifications?.[index]?.verified_status ? true : false
              }
              className={
                errors?.verifications?.[index]?.type &&
                `focus-visible:ring-red-500 border-red-500`
              }
            />
          </div>
        ) : (
          <></>
        )}

        {/* DOCUMENT NUMBER */}
        {method === 1 ? (
          <div className="space-y-2">
            <Label htmlFor="trust_id">
              <CustomLabelText
                required={false}
                labelText="Document Number"
                errorField={errors?.verifications?.[index]?.document_number}
              />
            </Label>
            <Input
              placeholder="Document Number"
              value={values?.verifications?.[index]?.document_number}
              onChange={(e) =>
                setFieldValue(
                  `verifications.${index}.document_number`,
                  e.target.value,
                )
              }
              disabled={
                values?.verifications?.[index]?.verified_status ? true : false
              }
              className={
                errors?.verifications?.[index]?.document_number &&
                `focus-visible:ring-red-500 border-red-500`
              }
            />
          </div>
        ) : (
          <></>
        )}

        {/* METHOD 3 Dynamic Fields */}
        {method === 3 ? (
          selectedType?.fields?.map((f) => (
            <div key={f.key} className="space-y-2">
              <Label htmlFor="trust_id">
                <CustomLabelText
                  required={false}
                  labelText={f.label}
                  errorField={
                    errors?.verifications?.[index]?.dynamicFields?.[f.key]
                  }
                />
              </Label>

              {f.inputType === "dropdown" ? (
                <Combobox
                  placeholder={`Select ${f.label}`}
                  value={values.verifications[index]?.dynamicFields?.[f.key]}
                  options={f.options.map((opt) => ({
                    label: opt.label,
                    value: opt.value,
                  }))}
                  onChange={(value) =>
                    setFieldValue(
                      `verifications.${index}.dynamicFields.${f.key}`,
                      value,
                    )
                  }
                  disabled={
                    values?.verifications?.[index]?.verified_status
                      ? true
                      : false
                  }
                  className={
                    errors?.verifications?.[index]?.dynamicFields?.[f.key] &&
                    `focus-visible:ring-red-500 border-red-500`
                  }
                />
              ) : f.inputType === "date" ? (
                values?.verifications?.[index]?.verified_status ? (
                  <Input
                    placeholder={f.label}
                    value={
                      values?.verifications?.[index]?.dynamicFields?.[f.key]
                        ? moment(
                            values?.verifications?.[index]?.dynamicFields?.[
                              f.key
                            ],
                          )?.format("DD-MM-YYYY")
                        : ""
                    }
                    readonly
                    disabled={
                      values?.verifications?.[index]?.verified_status
                        ? true
                        : false
                    }
                    className={
                      errors?.verifications?.[index]?.dynamicFields?.[f.key] &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                  />
                ) : (
                  <DateInputPicker
                    date={
                      values?.verifications[index].dynamicFields?.[f.key]
                        ? values?.verifications[index].dynamicFields?.[f.key]
                        : ""
                    }
                    onSelect={(e) => {
                      setFieldValue(
                        `verifications.${index}.dynamicFields.${f.key}`,
                        e,
                      );
                    }}
                    inputClassName="w-full"
                    className={
                      errors?.verifications?.[index]?.dynamicFields?.[f.key] &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabledDate={f?.future_date ? {} : { after: new Date() }}
                  />
                )
              ) : (
                <Input
                  placeholder={f.label}
                  value={values?.verifications?.[index]?.dynamicFields?.[f.key]}
                  onChange={(e) =>
                    setFieldValue(
                      `verifications.${index}.dynamicFields.${f.key}`,
                      e.target.value,
                    )
                  }
                  disabled={
                    values?.verifications?.[index]?.verified_status
                      ? true
                      : false
                  }
                  className={
                    errors?.verifications?.[index]?.dynamicFields?.[f.key] &&
                    `focus-visible:ring-red-500 border-red-500`
                  }
                />
              )}
            </div>
          ))
        ) : (
          <></>
        )}

        {method !== 1 && method ? (
          <>
            <div className="space-y-2">
              <Label htmlFor="trust_id">
                <CustomLabelText
                  required={false}
                  labelText="Verification Status"
                  // errorField={errors?.verifications?.[index]?.document_number}
                />
              </Label>

              <KYCVerifyModal
                loading={loading}
                setLoading={setLoading}
                values={values}
                index={index}
                verificationTypes={verificationTypes}
                kycId={kycId}
                setFieldValue={setFieldValue}
                method={method}
                organizationData={organizationData?.organizationData}
                verifyStatus={values?.verifications?.[index]?.verified}
                errors={errors}
                handleChange={handleChange}
                handleBlur={handleBlur}
              />
            </div>
          </>
        ) : (
          <></>
        )}

        {method == 1 && method ? (
          <>
            {/* Verification Date */}

            <div className="space-y-2">
              <Label htmlFor="trust_id">
                <CustomLabelText
                  required={false}
                  labelText="Verification Date"
                  errorField={errors?.verifications?.[index]?.date_verified}
                />
              </Label>
              {values?.verifications?.[index]?.verified_using ? (
                <Input
                  value={
                    values?.verifications?.[index]?.date_verified
                      ? moment(
                          values?.verifications?.[index]?.date_verified,
                        )?.format("DD-MM-YYYY")
                      : ""
                  }
                  readonly
                  disabled={
                    values?.verifications?.[index]?.verified_using
                      ? true
                      : false
                  }
                />
              ) : (
                <DateInputPicker
                  date={
                    values?.verifications[index]?.date_verified
                      ? values?.verifications[index]?.date_verified
                      : ""
                  }
                  onSelect={(e) => {
                    setFieldValue(`verifications.${index}.date_verified`, e);
                  }}
                  inputClassName="w-full"
                  className={""}
                  disabledDate={{ after: new Date() }}
                />
              )}
            </div>

            {/* Verified By */}

            <div className="min-w-0">
              <Label htmlFor="verified_by">
                <CustomLabelText
                  labelText="Verified By"
                  errorField={errors?.verified_by}
                />
              </Label>
              <div className="relative mt-2">
                <UserSelect
                  orgId={organizationData?.organizationId}
                  frameworkData={userListing} // List of vendors
                  optionType="User"
                  handleSelect={(e) => {
                    setFieldValue(`verifications.${index}.verified_by`, e);
                  }}
                  hideUserId={user}
                  name="verified_by"
                  disabled={
                    values?.verifications?.[index]?.verified_using
                      ? true
                      : false
                  }
                  initialValue={
                    values?.verifications?.[index]?.verified_by
                      ? values?.verifications?.[index]?.verified_by
                      : ""
                  }
                  authUser={true}
                  setUserList={setUserList}
                  setUserLoading={setUserLoading}
                  onClear={() => {
                    setFieldValue(`verified_by`, "");
                  }}
                  className={
                    errors?.verified_by &&
                    `focus-visible:ring-red-500 border-red-500`
                  }
                  loading={userLoading}
                />
                {userLoading && (
                  <span className="absolute top-2 right-2 animate-spin">
                    <Loader2 width={20} height={20} />
                  </span>
                )}
              </div>
            </div>

            {/* VERIFIED */}

            <div className="space-y-2">
              <Label htmlFor="trust_id">
                <CustomLabelText
                  required={false}
                  labelText="Verified"
                  errorField={errors?.verifications?.[index]?.verified}
                />
              </Label>

              <Combobox
                options={[
                  { label: "Yes", value: 1 },
                  { label: "No", value: 0 },
                ]}
                disabled={
                  values?.verifications?.[index]?.verified_using ? true : false
                }
                value={values.verifications[index]?.verified}
                placeholder="Select"
                onChange={(value) =>
                  setFieldValue(`verifications.${index}.verified`, value)
                }
              />
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
